import MainLayout from "../../layouts/MainLayOut";
import data from "./data/data"; // Replace with the correct data file

function PrivacyPolicy() {
  return (
    <MainLayout>
      <div
        className=" text-slate-300 z-20font-sans"
        style={{
          background:
            "radial-gradient(circle, rgba(51, 65, 85,1) 1%, rgba(2, 6, 23,1) 92%)",
        }}>
        <div className="w-full border-b border-slate-800"></div>

        <div className="px-6  md:pt-20  md:px-20 py-12 2xl:px-[10vw] mx-auto space-y-10">
          {/* Page Title */}
          <h1 className="text-4xl 2xl:text-[3vw] font-extrabold text-slate-100 tracking-tight">
            Our Terms &amp; Conditions
          </h1>

          {/* Intro Paragraph */}
          <p className="text-lg 2xl:text-[1.2vw] text-slate-400 leading-relaxed">
            This Privacy Policy explains how{" "}
            <span className="text-slate-200 font-medium">
              Token AI Labs Pvt. Ltd.
            </span>{" "}
            (“we”, “our”, or “us”) collects, uses, shares, and protects your
            personal information when you use our services. By using our
            services, you agree to the collection and use of information in
            accordance with this policy.
          </p>

          {/* Section Loop */}
          <div className="space-y-8">
            {data.map((ele, indexx) => (
              <div
                key={indexx}
                className="bg-slate-900/60 rounded-2xl p-6 md:p-8 border border-slate-800 shadow-inner backdrop-blur-sm space-y-4">
                {/* Main Section Title */}
                <div className="flex gap-2 items-center text-xl md:text-2xl font-semibold text-slate-100">
                  <span>{indexx + 1}.</span>
                  <h2>{ele?.title}</h2>
                </div>

                {/* Subsections */}
                <div className="mt-4 space-y-6">
                  {ele.data.map((subele, index) => (
                    <div key={`${ele.title}-${index}`} className="space-y-2">
                      {subele?.title && (
                        <div className="flex gap-2 items-center text-lg 2xl:text-[1.3vw] font-medium text-slate-200 ml-2">
                          <span>
                            {indexx + 1}.{index + 1}
                          </span>
                          <h3>{subele?.title}</h3>
                        </div>
                      )}
                      <p className="text-base text-slate-400 leading-relaxed ml-6 2xl:text-[1.1vw]">
                        {subele?.description}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="border-t border-slate-800 pt-6 text-sm text-slate-400">
            <p className="mb-2">
              For privacy-related inquiries, contact us at{" "}
              <a
                href="mailto:info@jaano.ai"
                className="text-slate-200 hover:underline">
                info@jaano.ai
              </a>
            </p>
            <p className="mb-1 font-medium text-slate-300">
              Token AI Labs Pvt. Ltd.
            </p>
            <p>
              415 Krushal Comm. Complex, Above Westside, G M Road, Chembur,
              Mumbai 400089. India
            </p>
            <a
              href="https://www.tokenailabs.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-200 hover:underline">
              www.tokenailabs.com
            </a>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default PrivacyPolicy;
